// شاشة الدخول والتسجيل — حقلان لا أكثر.
//
// اسم المستخدم يُحفظ على الجهاز بعد أول دخول، فيُفتح الحقل مملوءاً سلفاً
// ولا يكتب العائد إلا كلمة المرور. هذا يحلّ «الناس تنسى اسم المستخدم»
// بلا أن نجعل رقم الهاتف مفتاح دخول — وهو ما يفتح باب حجز أرقام الآخرين.

import { esc } from '../util.js';
import { api, ApiError } from '../api.js';
import { currencyChips, helpBtn } from '../ui.js';

const REMEMBER_KEY = 'familyWallet.v2.rememberedUsername';

export function freshDraft(){
  return {
    mode: 'login',            // login | register | recover
    username: remembered() || '',
    password: '',
    password2: '',
    recoveryCode: '',
    currency: 'ILS',      // تُختار مرة واحدة عند التسجيل
    busy: false,
    error: null,
    // يُعرض مرة واحدة بعد التسجيل ولا يمكن استعادته أبداً
    showRecovery: null
  };
}

function remembered(){
  try { return localStorage.getItem(REMEMBER_KEY) || ''; } catch { return ''; }
}
function remember(username){
  try { localStorage.setItem(REMEMBER_KEY, username); } catch { /* ignore */ }
}

export function render(app){
  const d = app.authDraft;

  if (d.showRecovery) return renderRecoveryCode(d);

  const isLogin = d.mode === 'login';
  const isRegister = d.mode === 'register';
  const isRecover = d.mode === 'recover';

  const title = isLogin ? 'تسجيل الدخول' : isRegister ? 'حساب جديد' : 'استرجاع الحساب';
  const sub = isLogin ? 'اسم المستخدم وكلمة المرور فقط'
            : isRegister ? 'حقلان وتبدأ — بلا بريد ولا رقم هاتف'
            : 'أدخل رمز الاسترجاع الذي حفظته عند التسجيل';

  return `
    <div class="authwrap">
      <div class="authcard">
        <div class="brand">
          <div class="brandmark">${wallet()}</div>
          <div class="ttl"><h1>محفظة العائلة</h1>${helpBtn()}</div>
          <p>سجّل مصروفاتك بأقل مجهود</p>
        </div>

        <div class="seg authseg">
          <button type="button" data-mode="login" aria-pressed="${isLogin}">دخول</button>
          <button type="button" data-mode="register" aria-pressed="${isRegister}">حساب جديد</button>
        </div>

        <h2 class="authtitle">${esc(title)}</h2>
        <p class="authsub">${esc(sub)}</p>

        ${d.error ? `<div class="autherr" role="alert">${esc(d.error)}</div>` : ''}

        <form id="authForm" novalidate>
          <div class="field">
            <label for="au">اسم المستخدم</label>
            <input id="au" name="username" type="text" inputmode="text"
                   autocomplete="username" autocapitalize="none" autocorrect="off"
                   spellcheck="false" dir="ltr" value="${esc(d.username)}"
                   placeholder="abuahmad أو 0599123456" required>
            ${isRegister ? `<span class="hint">
              اختر أي اسم تتذكّره — حروف إنجليزية وأرقام و <code>_ . - + @</code>.
              إن كتبت بريداً أو رقم هاتف فهو <b>مجرّد اسم</b>: لا نرسل إليه شيئاً،
              ولا يُستخدم في استرجاع الحساب.
            </span>` : ''}
          </div>

          ${isRecover ? `
          <div class="field">
            <label for="ar">رمز الاسترجاع</label>
            <input id="ar" name="recoveryCode" type="text" dir="ltr"
                   autocapitalize="characters" autocomplete="one-time-code"
                   placeholder="XXXX-XXXX-XXXX-XXXX" value="${esc(d.recoveryCode)}" required>
          </div>` : ''}

          <div class="field">
            <label for="ap">${isRecover ? 'كلمة المرور الجديدة' : 'كلمة المرور'}</label>
            <div class="pwwrap">
              <input id="ap" name="password" type="password"
                     autocomplete="${isLogin ? 'current-password' : 'new-password'}"
                     dir="ltr" value="${esc(d.password)}" required>
              <button type="button" class="pweye" data-act="toggle-pw" aria-label="إظهار كلمة المرور">👁</button>
            </div>
            ${!isLogin ? '<span class="hint">٨ أحرف على الأقل — جملة قصيرة أقوى من رموز معقّدة</span>' : ''}
          </div>

          ${isRegister ? `
          <div class="field">
            <label for="ap2">تأكيد كلمة المرور</label>
            <input id="ap2" name="password2" type="password" autocomplete="new-password"
                   dir="ltr" value="${esc(d.password2)}" required>
          </div>
          <div class="field">
            <label>عملة المحفظة</label>
            <div class="strip wrap">${currencyChips(d.currency, 'curpick')}</div>
            <span class="hint">تُختار مرة واحدة وتُستخدم في كل حركاتك — لن يُسألك عنها مجدداً.</span>
          </div>` : ''}

          <button type="submit" class="cta authcta" ${d.busy ? 'disabled' : ''}>
            ${d.busy ? '<span class="spin"></span> لحظة…'
                     : isLogin ? 'دخول' : isRegister ? 'إنشاء الحساب' : 'استرجاع'}
          </button>
        </form>

        <div class="authlinks">
          ${isRecover
            ? '<button type="button" data-mode="login">رجوع لتسجيل الدخول</button>'
            : '<button type="button" data-mode="recover">نسيت كلمة المرور؟</button>'}
        </div>

        <p class="authnote">
          بياناتك تُحفظ على جهازك وعلى خادمك أنت.
          التطبيق يعمل بلا إنترنت، ويزامن حين يعود الاتصال.
        </p>
      </div>
    </div>`;
}

/** يُعرض مرة واحدة فقط — بعدها لا سبيل لاستعادته. */
function renderRecoveryCode(d){
  return `
    <div class="authwrap">
      <div class="authcard">
        <div class="brand">
          <div class="brandmark ok">✓</div>
          <h1>أُنشئ حسابك</h1>
        </div>

        <div class="warnbar" style="margin:16px 0">
          <span>⚠</span>
          <span>احفظ رمز الاسترجاع هذا الآن. <b>لن يُعرض مرة أخرى أبداً.</b>
          بلا بريد ولا رقم هاتف، هذا الرمز هو وسيلتك الوحيدة لاستعادة حسابك
          إن نسيت كلمة المرور.</span>
        </div>

        <div class="reccode" id="recCode">${esc(d.showRecovery)}</div>

        <div class="btnrow" style="justify-content:center;margin:14px 0">
          <button type="button" class="btn" data-act="copy-code">نسخ الرمز</button>
          <button type="button" class="btn" data-act="download-code">حفظ كملف</button>
        </div>

        <label class="confirmrow">
          <input type="checkbox" id="recAck">
          <span>حفظتُ الرمز في مكان آمن</span>
        </label>

        <button type="button" class="cta authcta" data-act="finish" disabled id="recGo">
          ابدأ الاستخدام
        </button>
      </div>
    </div>`;
}

function wallet(){
  return `<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor"
    stroke-width="1.7" stroke-linejoin="round"><path d="M3 8.5h18v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-11Z"/>
    <path d="M3 8.5 6.5 3.4A1.5 1.5 0 0 1 7.8 2.8h8.4a1.5 1.5 0 0 1 1.3.6L21 8.5"/>
    <path d="M15 13.5h6v3.5h-6a1.75 1.75 0 0 1 0-3.5Z"/></svg>`;
}

/* ------------------------------------------------------------------ ربط */

export function mount(app, root){
  const form = root.querySelector('#authForm');
  const d = app.authDraft;

  if (form){
    // نقرأ من الحقول لا من الحالة عند الإرسال: تعبئة مدير كلمات المرور
    // التلقائية لا تُطلق أحداث input، فالحالة تبقى فارغة والمستخدم يرى
    // «كلمة المرور مطلوبة» بينما الحقل ممتلئ أمام عينيه.
    form.addEventListener('submit', ev => {
      ev.preventDefault();
      submit(app, new FormData(form));
    });

    // حفظ ما يُكتب حتى لا يضيع عند إعادة الرسم
    form.addEventListener('input', ev => {
      const t = ev.target;
      if (t.name === 'username') d.username = t.value;
      if (t.name === 'password') d.password = t.value;
      if (t.name === 'password2') d.password2 = t.value;
      if (t.name === 'recoveryCode') d.recoveryCode = t.value;
    });

    // البؤرة على الحقل الفارغ: الاسم محفوظ فيقفز المؤشر لكلمة المرور مباشرة
    const u = form.querySelector('#au');
    const p = form.querySelector('#ap');
    setTimeout(() => { (d.username && p ? p : u)?.focus(); }, 60);
  }

  const ack = root.querySelector('#recAck');
  if (ack){
    ack.addEventListener('change', () => {
      const go = root.querySelector('#recGo');
      if (go) go.disabled = !ack.checked;
    });
  }
}

export function onClick(app, btn){
  const d = app.authDraft;

  if (btn.dataset.mode){
    d.mode = btn.dataset.mode;
    d.error = null;
    d.password = ''; d.password2 = ''; d.recoveryCode = '';
    return app.render();
  }

  if (btn.dataset.curpick){ d.currency = btn.dataset.curpick; return app.render(); }

  const act = btn.dataset.act;

  if (act === 'toggle-pw'){
    const input = document.querySelector('#ap');
    if (input){
      input.type = input.type === 'password' ? 'text' : 'password';
      btn.textContent = input.type === 'password' ? '👁' : '🙈';
    }
    return;
  }

  if (act === 'copy-code'){
    const code = d.showRecovery || '';
    navigator.clipboard?.writeText(code)
      .then(() => app.toast('نُسخ رمز الاسترجاع'))
      .catch(() => app.toast('تعذّر النسخ — انسخه يدوياً'));
    return;
  }

  if (act === 'download-code'){
    const text =
      `محفظة العائلة — رمز الاسترجاع\n` +
      `اسم المستخدم: ${d.username}\n` +
      `رمز الاسترجاع: ${d.showRecovery}\n\n` +
      `احفظ هذا الملف في مكان آمن. هذا الرمز هو وسيلتك الوحيدة\n` +
      `لاستعادة حسابك إن نسيت كلمة المرور.\n`;
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `family-wallet-recovery-${d.username}.txt`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return;
  }

  if (act === 'finish'){
    d.showRecovery = null;
    return app.enterApp();
  }
  return false;
}

/* -------------------------------------------------------------- الإرسال */

async function submit(app, formData){
  const d = app.authDraft;
  if (d.busy) return;

  const username = String(formData.get('username') || '').trim();
  const password = String(formData.get('password') || '');
  const password2 = String(formData.get('password2') || '');
  const recoveryCode = String(formData.get('recoveryCode') || '').trim();

  d.username = username; d.password = password;
  d.password2 = password2; d.recoveryCode = recoveryCode;
  d.error = null;

  // فحص محلي قبل الشبكة: خطأ مطبعي لا يستحق رحلة إلى الخادم وانتظاراً
  if (!username) return fail(app, 'اكتب اسم المستخدم');
  if (username.length < 3) return fail(app, 'اسم المستخدم ٣ خانات على الأقل');
  if (!password) return fail(app, 'اكتب كلمة المرور');
  if (d.mode !== 'login' && password.length < 8) return fail(app, 'كلمة المرور ٨ أحرف على الأقل');
  if (d.mode === 'register' && password !== password2) return fail(app, 'كلمتا المرور غير متطابقتين');
  if (d.mode === 'recover' && recoveryCode.replace(/[^A-Za-z0-9]/g, '').length !== 16){
    return fail(app, 'رمز الاسترجاع ١٦ خانة');
  }

  d.busy = true;
  app.render();

  try {
    let res;
    if (d.mode === 'login')         res = await api.login(username, password);
    else if (d.mode === 'register') res = await api.register(username, password, d.currency);
    else                            res = await api.recover(username, recoveryCode, password);

    remember(username);
    d.busy = false;
    d.password = ''; d.password2 = ''; d.recoveryCode = '';

    if (d.mode === 'register' && res.recoveryCode){
      // نعرض الرمز قبل الدخول: بعد أن يرى المستخدم بياناته لن يعود إليه أبداً
      d.showRecovery = res.recoveryCode;
      app.session = { user: res.user, household: res.household };
      return app.render();
    }
    if (d.mode === 'recover' && res.recoveryCode){
      d.showRecovery = res.recoveryCode;
      const me = await api.me();
      app.session = { user: me.user, household: me.household };
      return app.render();
    }

    app.session = { user: res.user, household: res.household };
    return app.enterApp();

  } catch (err){
    d.busy = false;
    if (err instanceof ApiError){
      if (err.isOffline){
        return fail(app, 'لا يوجد اتصال بالخادم — تحقّق من الشبكة');
      }
      return fail(app, err.message);
    }
    console.error(err);
    return fail(app, 'حدث خطأ غير متوقّع');
  }
}

function fail(app, message){
  app.authDraft.error = message;
  app.authDraft.busy = false;
  app.render();
}
